import React, { useEffect } from 'react'
import {
	useSelector,
	useDispatch
} from 'react-redux'
import {
	selectAllAchievements,
	getAchievements
} from './achievementsSlice'
import classes from './Achievements.module.css'
import Spinner from "react-bootstrap/Spinner";


const Achievements = props => {
	const accountType = useSelector(state => state.users.current_user.account_type);

	const achievementsLoading = useSelector(state => state.achievements.loading)
	const achievements = useSelector(selectAllAchievements)
	const dispatch = useDispatch()
	useEffect(() => {
		if (accountType === "trainer") {
			const url = new URL(window.location.href);
			const client_id = url.searchParams.get('client');
			dispatch(getAchievements({ client_id: client_id }))
		} else {
			dispatch(getAchievements())
		}
	}, [])

	return (
		<>
			{achievementsLoading === "pending" ?
				<div className="d-flex justify-content-center mt-5">
					<Spinner animation="border" role="status">
						<span className="sr-only">Loading...</span>
					</Spinner>
				</div> :
				<div>
					<div style={{ flex: '1 1 auto' }}>
						<div className="text-center my-3">
							<h2 className="shadow" style={{
								padding: '16px 32px',
								background: '#000C2D',
								color: '#eee',
								borderRadius: '100px',
								display: 'inline-block'
							}}>
								<i style={{ color: '#4dd1ff' }} className="fas fa-trophy"></i> Achievements
							</h2>
						</div>
						<div className={classes.Achievements}>
							{achievements.map(achievement => (
								<div className={[classes.Achievement, 'shadow'].join(' ')}>
									<div className={classes.AchievementIcon}>
										<img src={achievement.icon} />
										<span>{achievement.iconOverlay}</span>
									</div>
									<div className="text-center" style={{ flex: '1 1 auto' }}>
										<div>
											<small className="text-muted">
												{new Date(achievement.datetime?.split(' ').join('T')).toLocaleDateString()}
											</small>
										</div>
										<div><strong>{achievement.title}</strong></div>
										{
											accountType === "client" && <div><small className="text-muted">{achievement.body}</small></div>
										}
									</div>
								</div>
							))}
						</div>
					</div>
					{accountType === "trainer" && achievements.length === 0 && 
						<div className="text-center">This client hasn't earned any achievements yet.</div>

					}
				</div>
			}

		</>

	)
}

export default Achievements